import { Tooltip } from '@mui/material'

export default function ReportTooltip(props) {
  return (
    <Tooltip
      {...props}
      slotProps={{ tooltip: { sx: { fontSize: '10px', lineHeight: 1.4 } } }}
    />
  )
}
